<div class="color-select" (click)="handleClick($event)">
  <ion-button
    class="color-select__select --{{ event | eventResponse | async | lowercase }}"
    [class.--big]="size === 'big'"
    (click)="openSelector()"
  >
    {{ "EVENT_RESPONSE_SELECTED." + (event | eventResponse | async) | translate }}
  </ion-button>
</div>
